import { render } from "./ResourceGroupPopup.vue?vue&type=template&id=5092d227&scoped=true&ts=true"
import script from "./ResourceGroupPopup.vue?vue&type=script&lang=ts"
export * from "./ResourceGroupPopup.vue?vue&type=script&lang=ts"

import "./ResourceGroupPopup.vue?vue&type=style&index=0&id=5092d227&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5092d227"]])

export default __exports__